const angular = require('angular');
const _module = require('../main-menu');

_module.factory('$fairHousingConfigStore', [
    '$http',

    function fairHousingConfigStore($http) {
        const NEST_URL = "https://nest.me";
        const obj = {};


        const url = NEST_URL + '/v1/config/fair-housing';
        return $http.get(url)
            .then(function(response) {
                Object.assign(obj, response.data.data);
                return obj;
            });

    },
]);
